(() => {
  const home = document.querySelector('.cf-home');
  if (!home) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const allowed = () => !reduced.matches && !document.body.classList.contains('cf-effects-paused');
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    observer.unobserve(entry.target);
    if (!allowed()) return;
    const animation = entry.target.animate([{opacity:.2,translate:'0 46px',clipPath:'inset(12% 0 0 0)'},{opacity:1,translate:'0 0',clipPath:'inset(0 0 0 0)'}],{duration:1100,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
    active.add(animation);animation.finished.then(()=>active.delete(animation),()=>active.delete(animation));
  }),{threshold:.1});
  home.querySelectorAll('.cf-visual-heading h2,.cf-look,.cf-closeup-title,.cf-closeup').forEach(el=>observer.observe(el));
  const sync=()=>{if(!allowed()) active.forEach(a=>a.cancel());};
  reduced.addEventListener('change',sync);
  new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
})();
